import { Component, Input } from "@angular/core";

@Component({
  selector: "app-save-indicator",
  templateUrl: "./save-indicator.component.html",
  standalone: false,
})
export class SaveIndicatorComponent {
  @Input()
  unsavedChanges: boolean = false;

  @Input()
  pendingUpload: boolean = false;

  @Input()
  tooltipUnsaved: string = "Aktuelle Änderungen wurden noch nicht gespeichert.";

  @Input()
  tooltipPending: string =
    "Die letzten Änderungen am Gutachten konnten nicht hochgeladen werden. Bis das automatische Hochladen im Hintergrund abgeschlossen ist, wird das Gutachten von der fairApp Web zwischengespeichert. Spätere Änderungen werden nach dem erneuten Speichern übernommen.";

  @Input()
  tooltipSaved: string = "Die Änderungen wurden erfolgreich hochgeladen.";
}
